<template>
  <div class="flex items-center">
    <vs-chip v-for="item in permissions" :key="item" :color="color(item)">{{ item }}</vs-chip>
  </div>
</template>

<script>
  export default {
    name: 'CellRendererPermissions',
    computed: {
      permissions() {
        return (this.$data.data[this.$data.data.column.permissions] ? this.$data.data[this.$data.data.column.permissions].split(',') : []);
      }
    },
    methods: {
      color(item) {
        if (item == 'ACC') {
          return 'success';
        } else if (item == 'IMP') {
          return 'warning';
        } else if ('ELI|ANU'.includes(item)) {
          return 'danger';
        } else {
          return 'primary';
        }
      }
    }
  }
</script>
